import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  minBy,
  noop,
  sortBy,
  get,
} from 'lodash';

import {
  Divider,
  HighlightText,
} from 'components';

import {
  toStartCase,
} from 'helpers/utils';

class StoreMobileTableRow extends Component {
  static propTypes = {
    data: PropTypes.shape({}).isRequired,
    fields: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    searchText: PropTypes.string,
    onClick: PropTypes.func,
  };

  static defaultProps = {
    searchText: '',
    onClick: noop,
  };

  getDetailedData = () => {
    const { data } = this.props;
    const detailData = [];
    const minCount = minBy(data.packrows, 'count').count;
    const image = data.image || null;

    data.packrows.forEach((packrow, index) => {
      if (packrow.count !== minCount) {
        detailData.push({
          ...data,
          ...packrow,
          category: data.productData.category,
          bulkTotalQty: 0,
          hide: [
            'action',
            'approved',
            'category',
            'description',
            'name',
            'qty',
            'sourcename',
            'status',
            'subname',
            'tags',
            'updatedAt',
            'sku',
            'image',
          ],
          image,
          id: data.id,
          index,
          name: data.productData.name,
          subname: data.productData.subname,
        });
        return;
      }

      detailData.push({
        ...data,
        ...packrow,
        bulkTotalQty: data.packrows[0].isBulk ? data.availableQuantity : 0,
        action: (
          <div className="group-item-action" style={{marginTop:'8px', marginBottom:'0px'}}>
            {data.productData.category && (
              <span className='category-title'>
                {toStartCase(get(data, 'productData.category'))}
              </span>
            )}
          </div>
        ),
        category: data.productData.category,
        image,
        id: data.id,
        index,
        isMinCount: true,
        name: data.productData.name,
        subname: data.productData.subname,
      });
    });

    const sortedDetailData = sortBy(detailData, 'count');
    const fixWithEqualCountData = sortedDetailData.map((sortedDetailDataItem, index) => (
      (index > 0 && sortedDetailDataItem.count === minCount) ? {
        ...sortedDetailDataItem,
        hide: [
          'action',
          'approved',
          'category',
          'description',
          'name',
          'qty',
          'sourcename',
          'status',
          'subname',
          'tags',
          'updatedAt',
        ],
      } : sortedDetailDataItem
    ));

    return fixWithEqualCountData;
  }

  render() {
    const {
      data,
      fields,
      searchText,
      onClick,
    } = this.props;
    const detailData = this.getDetailedData();

    return (
      <div>
        <Divider />
        <div
          className="table-card"
          onClick={() => onClick(data)}
        >
          {
            fields.map((field, index) => (
              <div key={index} className="card-item-group">
                {
                  detailData.map((row, rowIndex) => {
                    const value = field.render ? field.render({ ...row, setState: this.updateStateData }) : (row.isSeparator ? '' : row[field.name]);
                    const searchedValue = !field.searchDisabled && !field.render && searchText
                      ? <HighlightText text={value} highlight={searchText} /> : value;
                    const className = typeof field.className === 'function' ? field.className(row) : field.className;
                    const label = field.mobileLabel || field.label;
                    const isEmpty = row.hide && row.hide.indexOf(field.name) > -1;

                    if (field.mobileHidden || isEmpty) return null;
                    return (
                      <div
                        className="card-item"
                        key={rowIndex}
                      >
                        <div className="value">
                          <div className={className}>{searchedValue}</div>
                        </div>
                        {label && (
                          <div className="title">{label}</div>
                        )}
                      </div>
                    );
                  })
                }
              </div>
            ))
          }
        </div>
      </div>
    );
  }
}

export default StoreMobileTableRow;
